import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import userConfig from './user'
import verticalMenu from './vertical-menu'
import request from './request'
import component from "@/store/component";
import system from "@/store/system";
import researchReview from "@/store/research-review";
import uiPreferences from '@/store/ui-preferences'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    user: userConfig,
    system,
    request,
    verticalMenu,
    component,
    researchReview,
    uiPreferences,
  },
  strict: process.env.DEV,
})
